import React from 'react';
import styled, { css } from 'styled-components';
import { observer } from 'mobx-react';
import { PAY_ONLINE_MERRCO, PAY_ONLINE_MONERIS } from 'src/payments/constants';
import { PaymentBanner } from 'src/checkout/components/sections/payment/shared/banner';
import { useOnlineOptions } from './use-online-options';
import { HostedTokenizationForm } from '../../moneris/hosted-tokenization-form';
import WrappedPaysafeForm from '../../paysafe-form';
import { PayByBankDetails } from './pay-by-bank-details';

export const SAVE_TEST_ID = 'checkout-expansion-save-payment-delivery';

export const OnlinePaymentOptions = observer(
  (): JSX.Element => {
    const {
      showCreditCardInformation,
      creditCardError,
      idRequiredText,
      paymentMethod,
      merrcoPublicToken,
      isKioskOrder,
      handleSetPaysafeToken,
      handleSaveMonerisPayment,
      setCreditCardError,
      showPayByBankDetails,
    } = useOnlineOptions();

    return (
      <>
        {showPayByBankDetails && <PayByBankDetails />}
        {showCreditCardInformation && (
          <CreditCardContainer>
            <PaymentBanner
              description={creditCardError || idRequiredText}
              severity={creditCardError ? 'error' : 'info'}
            />
            {paymentMethod === PAY_ONLINE_MERRCO && !!merrcoPublicToken && (
              <WrappedPaysafeForm
                applyCartStyles
                merrcoPublicToken={merrcoPublicToken}
                onToken={handleSetPaysafeToken}
                hideSave={isKioskOrder}
                handleError={setCreditCardError}
              />
            )}
            {paymentMethod === PAY_ONLINE_MONERIS && (
              <HostedTokenizationForm
                applyCartStyles
                onSave={handleSaveMonerisPayment}
                handleError={setCreditCardError}
              />
            )}
          </CreditCardContainer>
        )}
      </>
    );
  }
);

const CreditCardContainer = styled.div`
  ${({ theme: { spaces } }) => css`
    display: flex;
    flex-direction: column;
    gap: ${spaces[4]};
    padding: ${spaces[4]};
  `}
`;
